<template>
  <transition name="au-slide">
    <div v-if="state.updateAvailable" class="au-banner" role="status">
      <i class="bi bi-arrow-repeat" aria-hidden="true"></i>
      <span>Une nouvelle version de {{ $branding.appName }} est disponible.</span>
      <button type="button" class="au-btn" @click="reload">Actualiser</button>
    </div>
  </transition>
</template>

<script setup>
import { useAppUpdate } from '../composables/useAppUpdate'

const { state, reload } = useAppUpdate()
</script>

<style scoped>
.au-banner {
  position: fixed;
  z-index: 1090;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border-radius: 12px;
  color: #f8fafc;
  background: rgba(15, 23, 42, 0.94);
  box-shadow: 0 18px 40px -12px rgba(15, 23, 42, 0.45);
  font-size: 14px;
}
.au-btn {
  border: 0;
  border-radius: 8px;
  padding: 6px 12px;
  font-weight: 600;
  color: #fff;
  background: #6366f1;
  cursor: pointer;
}
.au-slide-enter-active,
.au-slide-leave-active { transition: opacity 0.25s, transform 0.25s; }
.au-slide-enter-from,
.au-slide-leave-to { opacity: 0; transform: translate(-50%, 12px); }
</style>
